import bus from "../bus";
import { playerEvents } from "../player/events";

/**
 * Emit a pause for the player when el is clicked
 * @param  {Node} el
 */
export default function pausePlayerOnClick(el, source) {
  let tearDown = () => {};
  const iframe = el.querySelector("iframe");
  if (!iframe) {
    return;
  }
  el.addEventListener("click", onClick, true);
  function onClick(e) {
    // Hide trap
    el.classList.add("clicked");
    // Pause the player
    bus.emit(playerEvents.PAUSE);
    // Play based on source
    switch (source) {
      case "youtube":
        tearDown = playYouTube(iframe);
        break;
      case "soundcloud":
        tearDown = playSoundcloud(iframe);
        break;
      case "vimeo":
        tearDown = playVimeo(iframe);
        break;
      default:
        break;
    }
  }

  return {
    destroy: () => {
      el.removeEventListener("click", onClick);
      if (typeof tearDown === "function") {
        tearDown();
      }
    }
  };
}

function playYouTube(iframe) {
  const message = JSON.stringify({
    event: "command",
    func: "playVideo",
    args: []
  });
  iframe.contentWindow.postMessage(message, "*");
}

function playVimeo(iframe) {
  const message = JSON.stringify({
    method: "play"
  });
  iframe.contentWindow.postMessage(message, "*");
}

function playSoundcloud(iframe) {
  let destroy;
  import("soundcloud-widget").then(({ default: SoundcloudWidget }) => {
    let player = new SoundcloudWidget(iframe);
    player.play();
    destroy = () => {
      player = null;
    };
  });
  return destroy;
}
